import { defineMessages } from "react-intl";

export const sessionsMessages = defineMessages({
  "sessions.heading": {
    id: "sessions.heading",
    defaultMessage: "Self-Development",
  },
  "sessions.aside.title": {
    id: "sessions.aside.title",
    defaultMessage: "My Self-Development",
  },
  "sessions.aside.start-button": {
    id: "sessions.aside.start-button",
    defaultMessage: "Start new session",
  },
  "sessions.card.goals.title": {
    id: "sessions.card.goals.title",
    defaultMessage: "Goals",
  },
  "sessions.type.USER_SESSION": {
    id: "sessions.type.USER_SESSION",
    defaultMessage: "Private",
  },
  "sessions.card.type.USER_SESSION": {
    id: "sessions.card.type.USER_SESSION",
    defaultMessage: "Session",
  },
  "sessions.card.type.default": {
    id: "sessions.card.type.default",
    defaultMessage: "Self-Development",
  },
  //
  "sessions.new.steps.area.label": {
    id: "sessions.new.steps.area.label",
    defaultMessage: "Choose area",
  },
  "sessions.new.steps.area.caption": {
    id: "sessions.new.steps.area.caption",
    defaultMessage: "Area for development",
  },
  "sessions.new.steps.area.heading": {
    id: "sessions.new.steps.area.heading",
    defaultMessage: "Set area for your development",
  },
  "sessions.new.steps.area.perex": {
    id: "sessions.new.steps.area.perex",
    defaultMessage:
      "Select from four tailored development paths: the first enables you to enhance your top talents, the second focuses on improving lesser talents, the third offers targeted recommendations, and the fourth allows you to define your own development area.",
  },

  "sessions.new.steps.area.strengths.title": {
    id: "sessions.new.steps.area.strengths.title",
    defaultMessage: "Enhance and excel in my talents",
  },
  "sessions.new.steps.area.weaknesses.title": {
    id: "sessions.new.steps.area.weaknesses.title",
    defaultMessage: "Cultivate lesser skills to overcome obstacles",
  },
  "sessions.new.steps.area.recommended.title": {
    id: "sessions.new.steps.area.recommended.title",
    defaultMessage: "Uncover recommended paths for growth",
  },
  "sessions.new.steps.area.recommended.info": {
    id: "sessions.new.steps.area.recommended.info",
    defaultMessage:
      "To unlock tailored growth recommendations, ensure the following are filled in: business strategy (set by HR), and your position and aspired competency (editable by you in profile settings).",
  },
  "sessions.new.steps.area.fallback.title": {
    id: "sessions.new.steps.area.fallback.title",
    defaultMessage:
      "Complete the talent assessment first to receive personalized area recommendations.",
  },
  "sessions.new.steps.area.customarea.placeholder": {
    id: "sessions.new.steps.area.customarea.placeholder",
    defaultMessage: "Type your own area for growth",
  },
  "sessions.new.steps.area.next": {
    id: "sessions.new.steps.area.next",
    defaultMessage: "Next",
  },
  //
  "sessions.new.steps.goal.label": {
    id: "sessions.new.steps.goal.label",
    defaultMessage: "Set long-term goal",
  },
  "sessions.new.steps.goal.caption": {
    id: "sessions.new.steps.goal.caption",
    defaultMessage: "Goals give you focus",
  },
  "sessions.new.steps.goal.heading": {
    id: "sessions.new.steps.goal.heading",
    defaultMessage: "Set the long term goal",
  },
  "sessions.new.steps.goal.perex": {
    id: "sessions.new.steps.goal.perex",
    defaultMessage:
      "Goals give you focus. Goals help you measure progress and stay motivated.",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.1": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.1",
    defaultMessage: "Focus on building relationship",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.2": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.2",
    defaultMessage: "Focus on building relationship",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.3": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.3",
    defaultMessage: "Practice confidence",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.4": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.4",
    defaultMessage: "Learn to take constructive criticism",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.5": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.5",
    defaultMessage: "Discover your team members' personal talents",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.6": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.6",
    defaultMessage: "Develop a growth mindset",
  },
  "dict-list.dict-list.sessions.new.steps.goal.focusedlist.7": {
    id: "dict-list.sessions.new.steps.goal.focusedlist.7",
    defaultMessage: "Build a dynamic team",
  },
  //
  "sessions.new.steps.motivation.label": {
    id: "sessions.new.steps.motivation.label",
    defaultMessage: "Motivation",
  },
  "sessions.new.steps.motivation.caption": {
    id: "sessions.new.steps.motivation.caption",
    defaultMessage: "See yourself to excel",
  },
  "sessions.new.steps.motivation.heading": {
    id: "sessions.new.steps.motivation.heading",
    defaultMessage: "Motivation/visualization",
  },
  "sessions.new.steps.motivation.perex": {
    id: "sessions.new.steps.motivation.perex",
    defaultMessage: "Imagine a situation where you excel in this area.",
  },

  "dict-list.sessions.new.steps.motivation.focusedlist.1": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.1",
    defaultMessage:
      "Once there is a positive change - describe the people surrounding you–in your business and personal life.",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.10": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.10",
    defaultMessage: "When you work on it for a month, what will you get?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.11": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.11",
    defaultMessage: "How do you feel when you excel in it?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.12": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.12",
    defaultMessage:
      "How can your talents help you to achieve excellence in that?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.2": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.2",
    defaultMessage:
      "Once there is a positive change - what is the atmosphere in your business and personal life? How do you contribute to that atmosphere?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.3": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.3",
    defaultMessage:
      "Once there is a positive change - what are you most proud of?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.4": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.4",
    defaultMessage:
      "Once there is a positive change - when somebody asks you for mentoring advice, what do you tell them?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.5": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.5",
    defaultMessage:
      "Once there is a positive change - describe the steps you had to take to get to where you are.",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.6": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.6",
    defaultMessage:
      "Once there is a positive change - what would you have done differently to get here?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.7": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.7",
    defaultMessage:
      "When you think about your first steps, what will be your benefit and when? How can you measure the progress?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.8": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.8",
    defaultMessage:
      "Who will be the first to notice your progress? What will they tell you?",
  },
  "dict-list.sessions.new.steps.motivation.focusedlist.9": {
    id: "dict-list.sessions.new.steps.motivation.focusedlist.9",
    defaultMessage: "When you start, what will you enjoy about it?",
  },
  //
  "sessions.new.steps.actionsteps.label": {
    id: "sessions.new.steps.actionsteps.label",
    defaultMessage: "Set action steps",
  },
  "sessions.new.steps.actionsteps.caption": {
    id: "sessions.new.steps.actionsteps.caption",
    defaultMessage: "Be specific",
  },
  "sessions.new.steps.actionsteps.heading": {
    id: "sessions.new.steps.actionsteps.heading",
    defaultMessage: "Set your action steps",
  },
  "sessions.new.steps.actionsteps.perex": {
    id: "sessions.new.steps.actionsteps.perex",
    defaultMessage:
      "Create SMART goals (Specific, Measurable, Attainable, Realistic, Time-bound) - The more specific you can be with your action step, the higher the chance you’ll complete it.",
  },
  // align
  "sessions.edit.steps.align.label": {
    id: "sessions.edit.steps.align.label",
    defaultMessage: "Area and goal",
  },
  "sessions.edit.steps.align.caption": {
    id: "sessions.edit.steps.align.caption",
    defaultMessage: "Are you aligned with the area and the goal?",
  },
  "sessions.edit.steps.align.heading": {
    id: "sessions.edit.steps.align.heading",
    defaultMessage:
      "Are you still aligned with your area for development and the long term goal? ",
  },
  "sessions.edit.steps.align.perex": {
    id: "sessions.edit.steps.align.perex",
    defaultMessage: " ",
  },

  "sessions.edit.steps.align.area.caption": {
    id: "sessions.edit.steps.align.area.caption",
    defaultMessage: "Area of development",
  },
  "sessions.edit.steps.align.goal.caption": {
    id: "sessions.edit.steps.align.goal.caption",
    defaultMessage: "Long-term goal",
  },
  "sessions.edit.steps.align.confirm": {
    id: "sessions.edit.steps.align.confirm",
    defaultMessage: "Yes",
  },
  "sessions.edit.steps.align.adjust": {
    id: "sessions.edit.steps.align.adjust",
    defaultMessage: "No, I would like to adjust",
  },
  // reflect
  "sessions.edit.steps.reflect.label": {
    id: "sessions.edit.steps.reflect.label",
    defaultMessage: "Reflect",
  },
  "sessions.edit.steps.reflect.caption": {
    id: "sessions.edit.steps.reflect.caption",
    defaultMessage: "Reflection on the last session",
  },
  "sessions.edit.steps.reflect.heading": {
    id: "sessions.edit.steps.reflect.heading",
    defaultMessage: "Reflection on the last session",
  },
  "sessions.edit.steps.reflect.perex": {
    id: "sessions.edit.steps.reflect.perex",
    defaultMessage: "Here are the short-term goals you set last time",
  },
  "sessions.edit.steps.reflect.mark-all-as-completed": {
    id: "sessions.edit.steps.reflect.mark-all-as-completed",
    defaultMessage: "Mark all as completed",
  },
  "sessions.edit.steps.reflect.reflection-heading": {
    id: "sessions.edit.steps.reflect.reflection-heading",
    defaultMessage: "Last session’s reflection",
  },
  "sessions.edit.steps.reflect.reflection-questions-heading": {
    id: "sessions.edit.steps.reflect.reflection-questions-heading",
    defaultMessage: "Pick the question you want to reflect on:",
  },
  "dict-list.sessions.edit.steps.reflect.hints.1": {
    id: "dict-list.sessions.edit.steps.reflect.hints.1",
    defaultMessage: "What did you specifically learn from the last session?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.2": {
    id: "dict-list.sessions.edit.steps.reflect.hints.2",
    defaultMessage: "What were you happy with?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.3": {
    id: "dict-list.sessions.edit.steps.reflect.hints.3",
    defaultMessage: "What could you have done better?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.4": {
    id: "dict-list.sessions.edit.steps.reflect.hints.4",
    defaultMessage:
      "What did you do right to make the action steps successful?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.5": {
    id: "dict-list.sessions.edit.steps.reflect.hints.5",
    defaultMessage: "What issues did you encounter from the last session?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.6": {
    id: "dict-list.sessions.edit.steps.reflect.hints.6",
    defaultMessage: "Were there skills you felt you needed but didn't have?",
  },
  "dict-list.sessions.edit.steps.reflect.hints.7": {
    id: "dict-list.sessions.edit.steps.reflect.hints.7",
    defaultMessage: "What suggestions do you have for future action steps?",
  },
  "sessions.edit.steps.reflect.reflection.placeholder": {
    id: "sessions.edit.steps.reflect.reflection.placeholder",
    defaultMessage: "Type your own reflection",
  },

  // setaction
  "sessions.edit.steps.setaction.label": {
    id: "sessions.edit.steps.setaction.label",
    defaultMessage: "Set action steps",
  },
  "sessions.edit.steps.setaction.caption": {
    id: "sessions.edit.steps.setaction.caption",
    defaultMessage: "Be specific",
  },
  "sessions.edit.steps.setaction.heading": {
    id: "sessions.edit.steps.setaction.heading",
    defaultMessage: "Set your action steps",
  },
  "sessions.edit.steps.setaction.perex": {
    id: "sessions.edit.steps.setaction.perex",
    defaultMessage: "They should be achievable and measurable.",
  },

  "sessions.steps.textareastep.placeholder": {
    id: "sessions.steps.textareastep.placeholder",
    defaultMessage: "Type your own motivation",
  },
  "sessions.steps.goal.placeholder": {
    id: "sessions.steps.goal.placeholder",
    defaultMessage:
      "Type your own goal or choose a suggested one from the list below",
  },

  "sessions.steps.finished.title": {
    id: "sessions.steps.finished.title",
    defaultMessage: "Congratulations, you’ve completed your session!",
  },
  "sessions.steps.finished.perex": {
    id: "sessions.steps.finished.perex",
    defaultMessage: "Would you like to book the next session?",
  },
  "sessions.steps.finished.schedule-private": {
    id: "sessions.steps.finished.schedule-private",
    defaultMessage: "Or you can schedule your private session",
  },
  "sessions.steps.finished.datetime.separator": {
    id: "sessions.steps.finished.datetime.separator",
    defaultMessage: "at",
  },
  "sessions.steps.finished.button.skip": {
    id: "sessions.steps.finished.button.skip",
    defaultMessage: "Skip for now",
  },
  "sessions.steps.finished.button.schedule": {
    id: "sessions.steps.finished.button.schedule",
    defaultMessage: "Schedule the session",
  },

  "sessions.new.header": {
    id: "sessions.new.header",
    defaultMessage: "Back to the sessions",
  },
  "sessions.new.aside.title": {
    id: "sessions.new.aside.title",
    defaultMessage: "My session",
  },
  "sessions.new.aside.end-button": {
    id: "sessions.new.aside.end-button",
    defaultMessage: "End session",
  },
  "evaluation.modal.title": {
    id: "evaluation.modal.title",
    defaultMessage: "Give us feedback",
  },
  "evaluation.modal.skip": {
    id: "evaluation.modal.skip",
    defaultMessage: "Skip",
  },
  "evaluation.modal.share": {
    id: "evaluation.modal.share",
    defaultMessage: "Share",
  },
  "evaluation.modal.textfield.placeholder": {
    id: "evaluation.modal.textfield.placeholder",
    defaultMessage: "Share your thoughts with us...",
  },
  "dict.evaluation.questions.satisfaction_with_lessons.label": {
    id: "dict.evaluation.questions.satisfaction_with_lessons.label",
    defaultMessage: "How satisfied were you with the session?",
  },
  "dict.evaluation.questions.satisfaction_with_lessons.minLabel": {
    id: "dict.evaluation.questions.satisfaction_with_lessons.minLabel",
    defaultMessage: "Not satisfied",
  },
  "dict.evaluation.questions.satisfaction_with_lessons.maxLabel": {
    id: "dict.evaluation.questions.satisfaction_with_lessons.maxLabel",
    defaultMessage: "Extremely satisfied",
  },
  "dict.evaluation.questions.contribution_to_personal_growth.label": {
    id: "dict.evaluation.questions.contribution_to_personal_growth.label",
    defaultMessage:
      "To what extent did this session contribute to your personal growth?",
  },
  "dict.evaluation.questions.contribution_to_personal_growth.minLabel": {
    id: "dict.evaluation.questions.contribution_to_personal_growth.minLabel",
    defaultMessage: "Not at all",
  },
  "dict.evaluation.questions.contribution_to_personal_growth.maxLabel": {
    id: "dict.evaluation.questions.contribution_to_personal_growth.maxLabel",
    defaultMessage: "Significantly",
  },
  "dict.evaluation.questions.clarity_about_the_next_steps.label": {
    id: "dict.evaluation.questions.clarity_about_the_next_steps.label",
    defaultMessage:
      "How clear are you on the next action steps after this session?",
  },
  "dict.evaluation.questions.clarity_about_the_next_steps.minLabel": {
    id: "dict.evaluation.questions.clarity_about_the_next_steps.minLabel",
    defaultMessage: "Not clear",
  },
  "dict.evaluation.questions.clarity_about_the_next_steps.maxLabel": {
    id: "dict.evaluation.questions.clarity_about_the_next_steps.maxLabel",
    defaultMessage: "Very clear",
  },
});
